import React, { useState } from 'react';
import { Sparkles, Gift, ChevronRight } from 'lucide-react';
import { useLoyaltySummary, useAvailableRewards } from '../../lib/loyalty-hooks';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
interface LoyaltyCardProps {
  phone: string;
  restaurantId: string | number | undefined;
}
export function LoyaltyCard({
  phone,
  restaurantId
}: LoyaltyCardProps) {
  const {
    summary,
    loading: summaryLoading
  } = useLoyaltySummary(phone, restaurantId);
  const {
    rewards,
    loading: rewardsLoading
  } = useAvailableRewards(phone, restaurantId);
  const [showRewards, setShowRewards] = useState(false);
  if (!phone || phone.length < 8) return null;
  if (summaryLoading) {
    return <div className="animate-pulse flex items-center gap-3 p-3 rounded-xl bg-gray-50 border border-gray-100 mt-2" data-id="element-2210" data-mp="w46eadxt1dox">
        <div className="w-8 h-8 bg-gray-200 rounded-full" data-id="element-2211" data-mp="2lghzdbeqz8x8"></div>
        <div className="flex-1 space-y-2" data-id="element-2212" data-mp="2qgmizaaycjro">
          <div className="h-3 bg-gray-200 rounded w-1/3" data-id="element-2213" data-mp="2qfbfzcpbzg1m"></div>
          <div className="h-2 bg-gray-200 rounded w-1/4" data-id="element-2214" data-mp="19712ewzdiii0"></div>
        </div>
      </div>;
  }
  if (!summary) {
    return <div className="flex items-center gap-3 p-3 rounded-xl bg-brand-charcoal/5 border border-brand-charcoal/10 mt-2" data-id="element-2215" data-mp="1474ysyul8t2z">
        <div className="w-8 h-8 rounded-full bg-brand-charcoal/10 flex items-center justify-center shrink-0" data-id="element-2216" data-mp="1dz0ww9wocj77">
          <Sparkles className="w-4 h-4 text-brand-charcoal" data-id="element-2217" data-mp="q96qob6v1svx" />
        </div>
        <p className="text-sm text-gray-600 font-medium" data-id="element-2218" data-mp="qbb018nj3k3l">
          Con esta compra empiezas a acumular beneficios ✨
        </p>
      </div>;
  }
  const hasRewards = rewards && rewards.length > 0;
  return <>
      <div className="flex items-center justify-between p-3 rounded-xl bg-gradient-to-r from-[#1A1A1A] to-[#2A2A2A] border border-[#333] mt-2 shadow-sm" data-id="element-2219" data-mp="ubbcinr2hl80">
        <div className="flex items-center gap-3" data-id="element-2220" data-mp="2angpkev2z8oj">
          <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0 border border-white/5" data-id="element-2221" data-mp="25qq9vsn6uf3n">
            <Sparkles className="w-5 h-5 text-[#F5E9DA]" data-id="element-2222" data-mp="13c0th5lsl103" />
          </div>
          <div data-id="element-2223" data-mp="18bdpogyjzkfc">
            <p className="text-sm font-bold text-white" data-id="element-2224" data-mp="18auah80afa50">
              Tienes {summary.current_points || 0} puntos
            </p>
            <p className="text-xs text-white/70 font-medium" data-id="element-2225" data-mp="1cea19npoeg9s">
              Nivel {summary.current_level || 'Inicial'}
            </p>
          </div>
        </div>

        {hasRewards && <button type="button" onClick={() => setShowRewards(true)} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/10 hover:bg-white/20 transition-colors border border-white/10" data-id="element-2226" data-mp="knvt884cfy61">
            <Gift className="w-4 h-4 text-[#F5E9DA]" data-id="element-2227" data-mp="ye93ih4pjoyj" />
            <span className="text-xs font-bold text-white" data-id="element-2228" data-mp="yf0oky0oi4ak">
              {rewards.length}{' '}
              {rewards.length === 1 ? 'beneficio' : 'beneficios'}
            </span>
            <ChevronRight className="w-4 h-4 text-white/50" data-id="element-2229" data-mp="5w3p6sa026jm" />
          </button>}
      </div>

      <Modal isOpen={showRewards} onClose={() => setShowRewards(false)} title="Tus Beneficios Disponibles" data-id="element-2230" data-mp="3uirq6tj7o4pf">
        <div className="space-y-3 mt-4" data-id="element-2231" data-mp="3kl3ua09vcr5o">
          {rewards.map((reward: any) => <div key={reward.id} className="p-4 rounded-xl border border-gray-200 bg-gray-50 flex items-center justify-between gap-4" data-id="element-2232" data-mp="3kn6rp5dcpmkf">
              <div data-id="element-2233" data-mp="3bm0a0syyu5pl">
                <h4 className="font-bold text-gray-900" data-id="element-2234" data-mp="3bmicw8g4vi6h">
                  {reward.reward_name}
                </h4>
                <p className="text-sm text-gray-500" data-id="element-2235" data-mp="31um70b7t2nrp">
                  Válido hasta{' '}
                  {new Date(reward.expires_at).toLocaleDateString()}
                </p>
              </div>
              <div className="shrink-0" data-id="element-2236" data-mp="2sty0e1kqrpou">
                <Gift className="w-6 h-6 text-brand-charcoal" data-id="element-2237" data-mp="2sswh59tknww1" />
              </div>
            </div>)}
          <div className="pt-4" data-id="element-2238" data-mp="2nvd1c5h87c1z">
            <Button className="w-full" onClick={() => setShowRewards(false)} data-id="element-2239" data-mp="2nx7dauairttx">
              Entendido
            </Button>
          </div>
        </div>
      </Modal>
    </>;
}